import { useQuery } from '@tanstack/react-query';

import { type WalletTransactionType } from '../wallet';
import { walletsOverviewApi } from '../wallets-overview';

const keys = {
  overview: ['cafeteria', 'wallets-overview'] as const,
  transactions: (type?: WalletTransactionType) =>
    ['cafeteria', 'wallets-overview', 'transactions', type ?? 'all'] as const,
};

// Named distinctly from `useWalletQuery`/`useTopUpMutation` in use-wallet.ts (which are
// per-user) to avoid the barrel name collision documented there.
export function useWalletsOverviewQuery() {
  return useQuery({
    queryKey: keys.overview,
    queryFn: () => walletsOverviewApi.list(),
  });
}

export function useWalletsTransactionsQuery(type?: WalletTransactionType, limit = 200) {
  return useQuery({
    queryKey: keys.transactions(type),
    queryFn: () => walletsOverviewApi.transactions({ type, limit }),
  });
}
